'use strict';

function ForgotPassword() {
  this.id = null;
  this.extends = [_Secured, _AnalyticsData, _Paths];
  this._submitButton = null;
  this._session = new Session();
  this._analytics = new Analytics();

  this.init = function () {
    if (this._session.getAuthToken() !== '') {
      window.location.replace(this._DEFAULT_LOGGEDIN_PATH);
    }
    var schemaReq = new APIRequest('/schemas?filter=forgot_password', 'GET', null, $.proxy(this._onGetSchema, this));
    schemaReq.send();

    this._analytics.update(this.analyticsData, this);
  };

  this.initAllReady = function () {
    this._submitButton = $('.button', this.node).show();
  };

  this._onGetSchema = function (data, response, status) {
    if (response == 200) {
      var schema = JSON.parse(data[0].schema);

      $('form', this.node).mogo().create('SchemaValidation', {
        schema: schema,
        onSubmit: this._onValidate.bind(this)
      });
    } else {
      this._setButtonLoadState(false);
      console.error(response);
    }
  };

  this._onForgotPassword = function (data, response) {
    if (response == 200) {
      Cookies.set('reset_email_val', data.email_address);
      window.location.replace('/password-reset-sent');
    } else if (response == 404) {
      var emailAddress = $('#email_address').val();
      Cookies.set('reset_email_val', emailAddress);
      window.location.replace('/password-reset-sent');
    } else if (response == 503) {
      // Account services offline - forward to maintenance page
      location.replace(this.paths.maintenance);
    } else {
      this._setButtonLoadState(false);
      $('#Notification').mogo().get();
    }
  };

  this._setButtonLoadState = function (disabled) {
    if (disabled) {
      this._submitButton.mogo().setDisabledLoadState();
    } else {
      this._submitButton.mogo().removeDisabledLoadState();
    }
  };

  this._onValidate = function (resultObj) {
    if (resultObj.count == 0) {
      this._setButtonLoadState(true);
      var formAnalyticsID = $('form', this.node).data('analytics-id');
      var data = $('form', this.node).serializeFormToObj();
      var request = new APIRequest('/accounts/forgot_password', 'POST', data, $.proxy(this._onForgotPassword, this));
      request.send();

      this._analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
    }
    return false;
  };
}